import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createBillRate } from 'api/billRates/createBillRate'
import { billRatesKey } from './keys'

export const useCreateBillRateMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (request: Parameters<typeof createBillRate>[0]) =>
      createBillRate(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: billRatesKey })
    },
  })
}
